export var VELT_SDK_VERSION = '4.7.1-beta.5';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.7.1-beta.5': 'sha384-UZnWQGT4Nqmgik3UGVqKIyiNOZ2F6hxr/d7wfdWVN9s/935K3eeby6g2/iRbSh7F',
};
